import { render, staticRenderFns } from "./shipment-services.vue?vue&type=template&id=3ca09d2e&scoped=true&lang=pug"
import script from "./shipment-services.vue?vue&type=script&lang=ts"
export * from "./shipment-services.vue?vue&type=script&lang=ts"
import style0 from "./shipment-services.vue?vue&type=style&index=0&id=3ca09d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca09d2e",
  null
  
)

export default component.exports